import type { FaireProductEntity } from "../../entity_types/product";

export const p_rknv9s5ptv: FaireProductEntity = {
  token: "p_rknv9s5ptv",
  type: "product",
  name: "Organic Wool Mountain Hiker Socks",
  brandToken: "b_dtik0xdswq",
  brandName: "Maggie's Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/e204b5c88bfb15eadcac911f8c66e36ce04129397ebbab9b6c3868777ee7b098.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9d5801a944ae5e54f15fda0a4f3eb5349d3099031b6ed4e6bc2305d1e975e0a.jpeg",
    "https://cdn.faire.com/fastly/55e3e7a0f9b2519b1e6c43ea8948ec0fdcd8915fd20e3bf85c76ccdf95f60429.jpeg",
    "https://cdn.faire.com/fastly/ff124fd5d222016a279ea346d463d7d9fd8ea982e5887a43febefba3de16ddc6.jpeg",
    "https://cdn.faire.com/fastly/cf1569b8fe439524f42a217469c28c488cd572df44ad6c8fbafe383d0ad25fc3.jpeg",
    "https://cdn.faire.com/fastly/d2ba9dc27590fef0fb02fa1944553b68a9c038bdd9230ca11279aae87edf4ce7.jpeg",
    "https://cdn.faire.com/fastly/3d7ab2c100ea8997148cef76fec745251c938e53cc75ee2ec65a725fc163dbd6.jpeg",
  ],
  priceDollars: 15,
  description:
    "Our most popular wool sock. Amazingly soft and comfy, not itchy, with thick cushion throughout. Washable, thanks to a special patented chlorine-free anti-felt treatment certified to the Global Organic Textil Standard (GOTS).",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:40.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
